import React from 'react';

const About = () => {
    return (
        <div>
            <h2>Secret about us!!</h2>
        </div>
    );
};

export default About;